/** @file Horizontal mirror counterparts (E/W, NE/NW, SE/SW); N and S have none (§5.8). */
import type { Dir } from '@pose2d/format/types';

/** The direction a mirrored `dir` must take its animations from; undefined for N and S. */
export const COUNTERPART: Readonly<Partial<Record<Dir, Dir>>> = { E: 'W', W: 'E', NE: 'NW', NW: 'NE', SE: 'SW', SW: 'SE' };
